import { render } from "./NestedElement.vue?vue&type=template&id=59913d78"
import script from "./NestedElement.vue?vue&type=script&lang=js"
export * from "./NestedElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__